import { LoadingContext } from "@/contexts/LoadingContext/LoadingContext";
import { StandardContextProps } from "@/types/contextTypes";
import { useCallback, useState } from "react";

export const LoadingContextProvider = ({ children }: StandardContextProps) => {
  const [loadingCount, setLoadingCount] = useState(0);

  // console.log("LOADING COUNT: " + loadingCount);

  const startLoading = useCallback(() => {
    setLoadingCount((count: number): number => count + 1);
  }, []);

  const stopLoading = useCallback(() => {
    setLoadingCount((count: number): number => Math.max(0, count - 1));
  }, []);
  return (
    <LoadingContext.Provider
      value={{ isLoading: loadingCount > 0, startLoading, stopLoading }}
    >
      {children}
    </LoadingContext.Provider>
  );
};
